<style lang="scss" scoped>
.slide-11 {
  background-image: url("../../../assets/module4/slide11/background.jpg");
  background-size: cover;
  background-position: center;
  height: calc(100% - 60px);
  padding-top: 60px;
  padding-left: 118px;
  padding-right: 50px;
}
h1 {
  color: #f8dc61;
  font-size: 95px;
  // transform-origin: 100% 50%;
  transform: rotate(-3deg);
}
h2 {
  text-transform: uppercase;
  font-size: 43px;
  margin-left: 284px;
  margin-top: 40px;
  line-height: 52px;
  strong {
    font-size: 55px;
    color: #68378d;
  }
}
p {
  color: white;
}
.top {
  padding-top: 50px;
  padding-right: 350px;
  text-align: right;
}
.bottom {
  margin-top: 320px;
  padding-left: 427px;
  p {
    max-width: 883px;
  }
}
h3 {
  font-size: 53px;
  color: #68378d;
  line-height: 64px;
  margin-top: 50px;
  transform: rotate(-3deg) translateY(-30px);
}
h4 {
  font-size: 100px;
  line-height: 119px;
  text-align: right;
  margin-top: -50px;
  padding-right: 50px;
  .big {
    display: inline-block;
    font-size: 219px;
    color: #c90c0f;
    position: relative;
    transform: translateY(40%);
  }
}
</style>

<template>
  <div class="slide-11">
    <transition name="fadeLeft" appear>
      <img
        src="@/assets/module4/slide11/sophia-01.png"
        class="chars"
        v-show="slideIndex == 10"
      />
    </transition>
    <transition name="fadeLeft" appear>
      <div v-show="slideIndex == 10" class="delay-1">
        <h1>It’s time for our last game.</h1>
      </div>
    </transition>
    <transition name="fadeLeft" appear>
      <h2 class="delay-2" v-show="slideIndex == 10">
        As FAST Heroes, we must <strong>always be prepared</strong> so next we
        are going to practice what to say when we call the ambulance.
      </h2>
    </transition>
    <transition name="fadeLeft" appear>
      <img
        src="@/assets/module4/slide11/images.png"
        class="chars delay-4"
        v-show="slideIndex == 10"
      />
    </transition>
    <transition name="fadeLeft" appear>
      <div class="top delay-3" v-show="slideIndex == 10">
        <p>You can use your 107 script from Book 2 to practice with.</p>
      </div>
    </transition>
    <div class="bottom">
      <transition name="fadeLeft" appear>
        <p class="delay-5" v-show="slideIndex == 10">
          Imagine you are at home with your Grandhero and suddenly all their
          words are jumbled up.
        </p>
      </transition>
      <transition name="fadeLeft" appear>
        <div class="delay-6" v-show="slideIndex == 10">
          <h3>Don’t forget to call the</h3>
        </div>
      </transition>
      <transition name="fadeLeft" appear>
        <h4 v-show="slideIndex == 10" class="delay-7">
          Magic Number
          <div class="big">107</div>
        </h4>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showVideo: false
    };
  },
  props: ["slideIndex"]
};
</script>
